import { Category, SubCategory, CodeCategory } from '../entities';

export class CodeCategoryUtility {
    public static getCodeCategory(category: Category, subCategory: SubCategory): CodeCategory {
        return {
            categoryId: category._id,
            categoryName: category.name,
            subCategoryId: subCategory._id,
            subCategoryName: subCategory.name,
            name: `${category.name} | ${subCategory.name}`,
            _id: null
        };
    }

    public static getCodeCategoryAll(category: Category): CodeCategory {
        return {
            categoryId: category._id,
            categoryName: category.name,
            subCategoryId: null,
            subCategoryName: 'All',
            name: `${category.name} | All`,
            _id: null
        };
    }
}
